import { render, staticRenderFns } from "./branch-games-list.vue?vue&type=template&id=b003a504"
import script from "./branch-games-list.vue?vue&type=script&lang=js"
export * from "./branch-games-list.vue?vue&type=script&lang=js"
import style0 from "./branch-games-list.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/games/branch-games-list.vue
// module id = iS3i
// module chunks = 0